<section class="section-container">
  <div class="section-content" >
    <div class="content-container" >
      <div class="contrato-container"   >
        <div class="contract-header">
          <app-alert class="alert" customIcon="info" [dense]="true" type="info" [hideIcon]="true">
            <strong>Contrato de renegociação da dívida</strong>
          </app-alert>
          <button
            *ngIf="!(isMobileMatches | async).matches && !hasAuthenticatedEmployee"
            (click)="scrollToEnd()"
            mat-raised-button
            color="primary">
            <span>Aceitar Termos</span>
          </button>

          <button
            *ngIf="hasAuthenticatedEmployee"
            (click)="downloadRenegotiationContract()"
            mat-raised-button
            [disabled]="!acceptTerms"
            matTooltip="O botão de download do contrato só estará disponível após a aceitação dos termos."
            matTooltipClass="tooltip-font-size"
            [matTooltipDisabled]="acceptTerms"
            color="primary">
            <span>Download do contrato</span>
            <mat-icon style="margin-left: 4px;">download</mat-icon>
          </button>
        </div>
  
        <div class="outorgante-devedor">
          <p>
            Outorgante devedor: <strong>{{renegotiationResume?.outorganteDevedor}}</strong><br/>
            CPF: <strong>{{renegotiationResume?.cpf}}</strong> <br/>
            Outorgante credora: <strong>Grupo Casas Bahia S.A.</strong>
          </p>
          <p>
            O outorgante reconhece e confessa na melhor forma de direito que é devedor nesta data da importância abaixo, 
            decorrente de compras efetuadas a prazo ou financiada pela outorgada na data de 
            <strong>{{renegotiationResume?.outorganteData}}</strong>, 
            sob o contrato de numero <strong>{{contractId}}</strong>. 
            que em decorrência da dívida ora confessada, 
            o outorgante promete e se obriga a paga-la em parcelas mensais que compreende a amortização do valor principal e seus encargos devidos pelo refinanciamento. 
            Conforme o demonstrativo a seguir:
          </p>
        </div>
  
        <ul class="resume-container">
          <li>
            <span>
              Saldo Principal: <strong>{{ renegotiationResume?.saldoPrincipal }}</strong> 
            </span>
          </li>
  
          <li>
            <span>
              Vencida desde: <strong>{{ renegotiationResume?.dataVencidaDesde }}</strong> 
            </span>
          </li>
  
          <li>
            <span>
              Valor de Juros e Multa: <strong>{{ renegotiationResume?.jurosMulta }}</strong>	
            </span>
          </li>
  
          <li>
            <span>
              Total Devido: <strong>{{ renegotiationResume?.totalDevido }}</strong> 
            </span>
          </li>
  
          <li>
            <span>
              Valor de desconto: <strong>{{ renegotiationResume?.desconto }}</strong> 
            </span>
          </li>
  
          <li>
            <span>
              Saldo Renegociado: <strong>{{ renegotiationResume?.saldoRenegociado }}</strong> 
            </span>
          </li>
  
          <li>
            <span>
              Novo Plano: 
                <strong>
                  {{ renegotiationResume?.plano }}
                </strong>
            </span>
          </li>
  
          <li>
            <span>
              <strong>Data 1º Vencimento: {{ renegotiationResume?.dataVencimento }}</strong>
            </span>
          </li>
  
        </ul>
  
        <app-alert type="warning" [dense]="true" [customIcon]="'label_important'" title="Importante:">
          A falta de pagamento de qualquer parcela no seu vencimento importará na rescisão do presente termo de acordo e 
          uma nova inclusão no cadastro de inadimplentes SCPC/SERASA. 
        </app-alert>
  
        <div class="outorgante-devedor">
          <p>
            Todavia poderá a Credora por mera liberdade, receber o valor da prestação em atraso corrigida com juros ao mês, 
            contados desde a data de vencimento da parcela inadimplente.
          </p>
          <p>{{ renegotiationResume?.localDataAcordo }}</p>
        </div>
  
        <div class="accept-terms" [class.highlight-checkbox]="!showScrollButton">
          <mat-checkbox
            color="primary" 
            (change)="handleChangeAcceptTerms($event)"
            [checked]="acceptTerms"
            class="checkbox-terms">
            Li e concordo com os termos.
          </mat-checkbox>
        </div>
      </div>

      <div #scrollButton class="scroll-to-check-container">
        <button
          *ngIf="showScrollButton && (isMobileMatches | async).matches"
          class="scroll-to-check-btn"
          (click)="scrollToEnd()"
          mat-raised-button
          color="primary">
          <span>Aceitar Termos</span>
        </button>
      </div>
  
      <div class="plan-resume-container">
        <div class="resume">
          <p class="total"><strong>Resumo do pagamento</strong></p>
    
          <div class="resume-item">
            <span>Valor da entrada</span> <span class="total-installment"><strong>{{selectedPlan?.valorEntrada | currency:'BRL'}}</strong></span>
          </div>
    
          <div class="resume-item">
            <span>Data de Vencimento</span> <span class="total-installment"><strong>{{ renegotiationResume?.dataVencimento }}</strong></span>
          </div>

          <div *ngIf="selectedPlan?.parcelas > 1" class="resume-item">
            <span>Próximas parcelas</span> <strong>{{ selectedPlan?.parcelas }}x {{selectedPlan?.valor | currency:'BRL'}}</strong>
          </div>
          <hr />
    
          <p *ngIf="permitirPagamentoPix" class="total"><strong>Selecione a forma de pagamento</strong></p>
    
          <div *ngIf="permitirPagamentoPix" class="checkout-options">
            <button 
              class="checkout-item" 
              [class.selected]="checkoutType === 'pix'" 
              (click)="checkoutType = 'pix'"
              [disabled]="disabledCheckoutTypeButton"
              matTooltipClass="tooltip-font-size"
              [matTooltip]="checkoutButtonTooltipText"
              [matTooltipDisabled]="!disabledCheckoutTypeButton"
              >
              <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.52734 15.2849L3.48828 12.2447H3.96289C4.27108 12.2462 4.57638 12.1863 4.86133 12.0689C5.14628 11.9514 5.40537 11.7791 5.62305 11.5609L8.03516 9.14983C8.11996 9.06985 8.23111 9.02479 8.34766 9.02479C8.46421 9.02479 8.57731 9.06985 8.66211 9.14983L11.0625 11.5511C11.2802 11.7702 11.5389 11.9427 11.8242 12.0611C12.1095 12.1794 12.4158 12.2396 12.7246 12.2389H13.0137L9.96289 15.2849C9.73747 15.5115 9.46891 15.6917 9.17383 15.8144C8.87874 15.9371 8.56174 16 8.24219 16C7.92263 16 7.60563 15.9371 7.31055 15.8144C7.01546 15.6917 6.74886 15.5115 6.52344 15.2849H6.52734ZM0.960938 9.71449C0.506061 9.25808 0.25 8.63962 0.25 7.99512C0.25 7.35061 0.506061 6.73215 0.960938 6.27574L2.8125 4.42936C2.85206 4.44335 2.8936 4.45155 2.93555 4.4528H3.96289C4.17863 4.45245 4.3924 4.49545 4.5918 4.57785C4.79119 4.66025 4.9724 4.78089 5.125 4.93345L7.53516 7.34058C7.64126 7.44836 7.76858 7.5326 7.9082 7.59067C8.04783 7.64874 8.19644 7.67936 8.34766 7.67859C8.49955 7.67891 8.65064 7.6487 8.79102 7.59067C8.93139 7.53264 9.05865 7.44806 9.16602 7.34058L11.5664 4.94322C11.7191 4.78992 11.8999 4.66875 12.0996 4.58566C12.2993 4.50258 12.5142 4.4608 12.7305 4.46062H13.5664C13.6107 4.46142 13.6545 4.4525 13.6953 4.43522L15.5352 6.27574C15.7617 6.50109 15.9418 6.76801 16.0645 7.06313C16.1872 7.35825 16.25 7.67549 16.25 7.99512C16.25 8.31474 16.1872 8.63198 16.0645 8.9271C15.9418 9.22222 15.7617 9.48914 15.5352 9.71449L13.6953 11.5609C13.6549 11.5417 13.6111 11.5309 13.5664 11.5296H12.7305C12.5145 11.5304 12.2994 11.4888 12.0996 11.4065C11.8999 11.3243 11.7193 11.2035 11.5664 11.0509L9.16602 8.64965C8.94632 8.43984 8.65335 8.32336 8.34961 8.32336C8.04587 8.32336 7.75486 8.43984 7.53516 8.64965L5.125 11.0568C4.9724 11.2093 4.79119 11.33 4.5918 11.4124C4.3924 11.4948 4.17863 11.5378 3.96289 11.5374H2.93555C2.89289 11.5378 2.85081 11.548 2.8125 11.5667L0.960938 9.71449ZM8.03516 6.8404L5.62305 4.43913C5.40558 4.22024 5.14625 4.04748 4.86133 3.92917C4.5764 3.81087 4.27138 3.75087 3.96289 3.75137H3.48828L6.52734 0.711198C6.98406 0.256276 7.60158 0 8.24609 0C8.89061 0 9.51008 0.256276 9.9668 0.711198L13.0176 3.76505H12.7285C12.4201 3.76298 12.1134 3.82182 11.8281 3.93894C11.5428 4.05606 11.2845 4.22876 11.0664 4.44694L8.66602 6.84821C8.62565 6.8908 8.57734 6.92468 8.52344 6.94786C8.46954 6.97104 8.41218 6.98303 8.35352 6.98303C8.29485 6.98303 8.23554 6.97104 8.18164 6.94786C8.12774 6.92468 8.07943 6.8908 8.03906 6.84821L8.03516 6.8404Z"/>
              </svg>
              <span>Pix</span>
            </button>
    
            <button 
              class="checkout-item" 
              [class.selected]="checkoutType === 'boleto'" 
              (click)="checkoutType = 'boleto'"
              [disabled]="disabledCheckoutTypeButton"
              [matTooltip]="checkoutButtonTooltipText"
              matTooltipClass="tooltip-font-size"
              [matTooltipDisabled]="!disabledCheckoutTypeButton"
              >
              <svg width="20" height="16" viewBox="0 0 20 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.25" width="2" height="16" rx="1" />
                <rect x="17.25" width="2" height="16" rx="1" />
                <rect x="5.25" width="2" height="16" rx="1" />
                <rect x="10.25" width="4" height="16" rx="2" />
                </svg>
              <span>Boleto</span>
            </button>
          </div>
  
          <button 
            type="button" 
            class="pay-button"
            mat-flat-button
            [matTooltip]="paymentButtonTooltipText"
            matTooltipClass="tooltip-font-size"
            [matTooltipDisabled]="!disabledPaymentButton"
            [disabled]="disabledPaymentButton" 
            (click)="efetivarAcordo()"
            color="primary">
              <span> 
                Pagar entrada
              </span>
          </button>
        </div>
    
        <app-alert type="info" [dense]="true" title="Importante:">
          Para prosseguir com a renegociação, é necessário ler o contrato até o final e aceitar os termos.
        </app-alert>
      </div>
    </div>

  </div>
</section>